import { useEffect, useState } from "react";

import { routes } from "routes";
import { IUser } from "services/types";
import { useTrendingCreators } from "queries";

import { IUserInfo } from "./types";
import { UserListWidgetAlive } from "components/widgets/UserListWidgetAlive";

interface ITrendingCreatorsProps {
  list?: boolean;
}

export const TrendingCreators = (props: ITrendingCreatorsProps) => {
  const [items, setItems] = useState<IUserInfo[]>([]);

  const query = useTrendingCreators();

  useEffect(() => {
    if (query.isSuccess && query.data) {
      const ix = query.data.map((el: IUser): IUserInfo => ({
        id: el.username,
        name: el.name ?? el.username,
        image: el.profileImageUrl ?? el.thumbnail,
        following: false,
        verified: el.verified,
      }));

      setItems(ix);
    }
  }, [query.isSuccess, query.data]);

  return (
    <UserListWidgetAlive
      className="trendingCreators"
      title="🔥️ Trending Creators"
      link={routes.exploreCreators()}
      items={[...items]}
      list={props.list}
      context={null}
    />
  );
};
